module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/5-e49efd79bf2c9ca0b66b642d028da93c.png";